<template>
	<div>
		<pageHead></pageHead>
		<div class="service-main">
			<page-banner :title="'服务内容'" :breadTxt="'渗透测试'" :tipTxt="'提供“规范、科学、公正、专业、诚信”的等级保护测评服务'"></page-banner>
			
			<p class="t-align-center serviceT mt-50">渗透测试</p>
			<p class="t-align-center serviceT mt-10 mb-20">Penetration testing services</p>
			<div class="m-0auto maxw-1400 pb-50">
				<img src="../../assets/img/service/u32.png" class="pb-20"/>
				<p class="f-blue fz-24 line-50 f-bold">渗透测试概述</p>
				<p class="t-indent2 fz-24 line-26">在用户授权的前提下，以模拟黑客攻击的方式，对用户网站的安全漏洞、安全隐患全面检测，找出网站的安全漏洞、评估网站的安全状态、提供漏洞修复建议。</p>
				<p class="t-indent2 fz-24 line-26 mb-50">在渗透过程中，会采用业界的漏洞检测技术、攻击技术、攻击工具，过程分为四步：计划与准备、信息收集、实施渗透、输出报告。</p>
				<p class="f-blue fz-24 line-50 f-bold">服务收益</p>
				<p class="fz-24 line-26">对网站进行渗透测试，可为用户带来如下收益；</p>
				<div class="li-w pb-50">
					<li>评估网站中存在的安全隐患、安全隐患；</li>
					<li>发现网站存在的深层次安全隐患；</li>
					<li>验证网站现有安全措施的防护强度</li>
					<li>达到监管机构相关政策要求；</li>
					<li>评估网站被入侵的可能性，并在入侵者发起攻击前封堵可能被利用的攻击途径。</li>
				</div>
				<p class="f-blue fz-24 line-50 f-bold">渗透测试内容</p>
				<p class="t-indent2 fz-24 line-26 mb-50">通过模拟黑客对目标系统进行渗透测试，包括B/S、C/S、移动应用 (APP)、微信小程序等形态的信息系统，发现分析并验证其存在的框架安全漏洞、敏感信息泄露、SQL注入漏洞、跨站脚本漏洞以及弱口令等安全隐患，评估系统抗攻击能力，提出安全加固建议。</p>
				<div class="t-align-center">
					<img src="../../assets/img/service/u33.png" style="width: 50%;"/>
				</div>
			</div>
		</div>
		
		<page-foot></page-foot>
	</div>
</template>

<script>
	import pageHead from '../../components/pageHead'
	import pageBanner from '../../components/pageBanner'
	import pageFoot from '../../components/pagefoot'
	export default{
		components:{
			pageHead,
			pageBanner,
			pageFoot
		},
		data(){
			return {
				
			}
		},
		methods:{
			
		}
	}
</script>

<style scoped>
.proBox{
	width: 100%;
	max-width: 1400px;
	height: auto;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-around;
	margin: 20px auto;
	border-radius: 15px;
}
.serviceT{
	font-size: 24px;
	font-weight: 800;
}
img{
	width: 100%;
}
.li-w{
	display: flex;
	flex-wrap: wrap;
}
.li-w>li{
	min-width: 50%;
	font-size: 24px;
	line-height: 300%;
	color: #808080;
}
li::marker{
	color: #4264b5;
	font-size: 2rem;
}
</style>